import api from '@pray/shared/utils/api';

/**
 * Fetch announcement statistics (aggregate counts)
 *
 * Returns accurate total, sent, scheduled, and draft counts
 * directly from the database without pagination.
 *
 * @param {Object} options
 * @param {string} options.artistId - Artist ID (required)
 * @returns {Promise<{ total: number, sent: number, scheduled: number, draft: number }>}
 */
export async function getAnnouncementStats({ artistId = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/announcements/stats`;
  const response = await api.executeGetRequest(url);

  // sendSuccessResponse wraps data as: { data: [{ resource: { ...stats } }] }
  const resource = response?.data?.data?.[0]?.resource;
  return resource || response.data;
}
